<div id="session-time-out-utf" [ngClass]=" showSessionPopUp? 'open-utf-session-time-out-modal' : 'hide-utf-popup' ">
  <app-session-timeout-utf-modal [openModal]="openPopUp" (closeModal)="closeSessionTimeOut($event)">
  </app-session-timeout-utf-modal>
</div>